import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="login-page" data-testid="login-page">
      <div className="login-card">
        <div className="logo">Legis<em> BC</em></div>
        <div className="sub">Panel de administración</div>
        <form onSubmit={submit}>
          <label>Correo electrónico</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" placeholder="admin@legis.mx" />
          <label>Contraseña</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" placeholder="••••••••" />
          {error && <div className="err" data-testid="login-error">{error}</div>}
          <button className="btn" type="submit" disabled={loading} data-testid="login-submit-button">
            {loading ? "Entrando…" : "Iniciar sesión"}
          </button>
        </form>
        <Link className="back" to="/" data-testid="login-back-link">← Volver al sitio público</Link>
      </div>
    </div>
  );
}
